import get from 'lodash.get'

import { fetchPaymentMethods } from '@http/endpoints'
import { isPaymentMethodEnabled, productPaymentAdvertising } from '@payment'

export default {
  namespaced: true,

  /**
   * @typedef {Object} State
   * @property {import('@payment').PaymentMethod[]} methods
   * @property {import('../modules/common').PaymentConfig} config
   *
   * @returns {State}
   */
  state: () => ({
    methods: [],
    config: {
      adyenEncryption: { key: '', time: '' },
      signifydFingerprint: null,
    },
  }),

  mutations: {
    /**
     * @param {State} state
     * @param {import('@payment').PaymentMethod[]} methods
     */
    setMethods(state, methods) {
      state.methods = methods
    },

    /**
     * @param {State} state
     * @param {import('../modules/common').PaymentConfig} config
     */
    setConfig(state, config) {
      state.config = config
    },
  },

  getters: {
    /**
     * @param {State} state
     * @returns {import('@payment').PaymentMethod[]}
     */
    methods: (state) => state.methods,

    /**
     * @param {State} state
     * @param {Object} getters
     */
    enabledMethods: (state, { methods }) =>
      methods.filter(isPaymentMethodEnabled),

    /**
     * @param {State} state
     * @param {Object} getters
     * @param {Object} rootGetters
     */
    advertisedMethodsId: (state, { methods }) =>
      get(productPaymentAdvertising(methods).advertised, 'methods', [])
        .map((method) => method.bmCode)
        .join('_') || null,

    /**
     * @param {State} state
     * @returns {import('../modules/common').PaymentConfig}
     */
    config: (state) => state.config,
  },

  actions: {
    /**
     * @param {import('vuex').ActionContext<State, Object>} context
     * @param {import('../modules/common').PaymentConfig & Object} payload
     */
    async set({ commit }, { adyenEncryption, signifydFingerprint }) {
      commit('setConfig', { adyenEncryption, signifydFingerprint })
    },

    /**
     * @param {import('vuex').ActionContext<State, Object>} context
     * @param {Object} payload
     * @param {string[]} payload.cartItemsIds
     * @param {import('@http/transformResponse/transformResponse').Price} payload.cartPrice
     */
    async fetchMethods(
      { commit, dispatch, rootGetters },
      { cartItemsIds, cartPrice },
    ) {
      const { payload } = await dispatch(
        'http/request',
        {
          request: fetchPaymentMethods,
          queryParams: {
            country_code: rootGetters['config/country'],
            listings: cartItemsIds.join(','),
            bag_price: cartPrice.amount,
          },
        },
        { root: true },
      )
      commit('setMethods', payload.results)
    },
  },
}
